module.exports = __webpack_public_path__ + "img/h_slot_machine.a99e2b13.png";